// Recovered compiled webpack factory 3865. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      PathParamsContext: function () {
        return i;
      },
      PathnameContext: function () {
        return o;
      },
      SearchParamsContext: function () {
        return a;
      },
    }));
  let n = r(12115),
    a = (0, n.createContext)(null),
    o = (0, n.createContext)(null),
    i = (0, n.createContext)(null);
}
